var React = require('react');

function IconLayer (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("g",{"key":1},React.createElement("g",{"id":"Layer_1"},React.createElement("g",null,[React.createElement("path",{"className":"cls-1","d":"M8,1.3L0,4.7h0s8,3.4,8,3.4h0s8-3.4,8-3.4L8,1.3h0Z","key":0}),React.createElement("path",{"className":"cls-1","d":"M8,9.6l-5.3-2.2-2.7,1.1,8,3.4,8-3.4-2.8-1.2-5.2,2.2Z","key":1}),React.createElement("path",{"className":"cls-1","d":"M8,13.3l-5.3-2.2-2.7,1.1,8,3.4,8-3.4-2.8-1.2-5.2,2.2Z","key":2})])))]);
}

IconLayer.defaultProps = {"version":"1.1","viewBox":"0 0 16 16"};

module.exports = IconLayer;

IconLayer.default = IconLayer;
